import useHasGasTank from './useHasGasTank'

export default useHasGasTank
